import { render } from "./ProductGrid.vue?vue&type=template&id=fcf13dd0"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"

import exportComponent from "/Users/williamsandstrom/repos/web/ytopi/ytopi-configurator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__